/*
 *
 * Auth actions
 *
 */

import * as actions from "./constants";

export function loginUser(values) {
  return {
    type: actions.LOGIN_USER,
    data: values,
  };
}

export function loginUserSuccess(response) {
  return {
    type: actions.LOGIN_USER_SUCCESS,
    data: response,
  };
}

export function logoutUser() {
  return {
    type: actions.LOGOUT_USER,
  };
}

export function checkToken() {
  return {
    type: actions.CHECK_TOKEN,
  };
}
